if (!customElements.get('afs-budget-collection')) {
  customElements.define('afs-budget-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-afs-labels]').textContent);
      this.form = this.querySelector('form');
      this.min = this.querySelector('[data-afs-min]');
      this.max = this.querySelector('[data-afs-max]');
      this.sort = this.form.querySelector('[name="sort_by"]');
      this.stock = this.querySelector('[data-afs-stock]');
      this.grid = this.querySelector('[data-afs-products]');
      this.pages = this.querySelector('[data-afs-pages]');
      this.loading = this.querySelector('[data-afs-loading]');
      this.failure = this.querySelector('[data-afs-failure]');
      this.error = this.querySelector('[data-afs-error]');
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency',currency:this.dataset.currency});
      this.onPop = () => {this.sync();this.render();};
      window.addEventListener('popstate', this.onPop);
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (this.min.value !== '' && this.max.value !== '' && Number(this.min.value) > Number(this.max.value)) {
          this.error.hidden = false;this.max.setAttribute('aria-invalid','true');this.max.focus();return;
        }
        const url = new URL(window.location.href);
        for (const key of ['filter.v.price.gte','filter.v.price.lte','filter.v.availability','sort_by','page']) url.searchParams.delete(key);
        if (this.min.value !== '') url.searchParams.set('filter.v.price.gte',this.min.value);
        if (this.max.value !== '') url.searchParams.set('filter.v.price.lte',this.max.value);
        if (this.stock.checked) url.searchParams.set('filter.v.availability','1');
        url.searchParams.set('sort_by',this.sort.value);
        this.navigate(url);
      });
      this.form.addEventListener('input',()=>{this.error.hidden=true;this.max.removeAttribute('aria-invalid');});
      this.querySelectorAll('[data-afs-budget]').forEach(link => link.addEventListener('click',event=>{
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const url = new URL(window.location.href);
        for (const key of ['filter.v.price.gte','filter.v.price.lte','page']) url.searchParams.delete(key);
        if (link.dataset.min !== '') url.searchParams.set('filter.v.price.gte',link.dataset.min);
        if (link.dataset.max !== '') url.searchParams.set('filter.v.price.lte',link.dataset.max);
        this.navigate(url);
      }));
      this.querySelector('.afs-catalog-clear').addEventListener('click',event=>{
        event.preventDefault();const url=new URL(this.dataset.collectionUrl,window.location.origin);url.searchParams.set('sort_by',this.sort.value);this.navigate(url);
      });
      this.querySelector('[data-afs-retry]').addEventListener('click',()=>this.load());
      this.sync();this.load();
    }
    disconnectedCallback() {window.removeEventListener('popstate',this.onPop);}
    navigate(url) {window.history.pushState({},'',url);this.sync();this.render();}
    sync() {
      const url=new URL(window.location.href);
      this.min.value=url.searchParams.get('filter.v.price.gte')||'';
      this.max.value=url.searchParams.get('filter.v.price.lte')||'';
      this.stock.checked=url.searchParams.get('filter.v.availability')==='1';
      const requested=url.searchParams.get('sort_by')||this.dataset.defaultSort||'manual';
      this.sort.value=Array.from(this.sort.options).some(option=>option.value===requested)?requested:'manual';
      const clearUrl=new URL(this.dataset.collectionUrl,window.location.origin);clearUrl.searchParams.set('sort_by',this.sort.value);this.querySelector('.afs-catalog-clear').href=clearUrl.toString();
      this.querySelectorAll('[data-afs-budget]').forEach(link=>{
        const target=new URL(url);target.searchParams.delete('page');target.searchParams.delete('filter.v.price.gte');target.searchParams.delete('filter.v.price.lte');
        if(link.dataset.min!=='')target.searchParams.set('filter.v.price.gte',link.dataset.min);
        if(link.dataset.max!=='')target.searchParams.set('filter.v.price.lte',link.dataset.max);
        link.href=target.toString();link.removeAttribute('aria-current');
        if((this.min.value===link.dataset.min||(this.min.value===''&&link.dataset.min==='0'))&&this.max.value===link.dataset.max)link.setAttribute('aria-current','true');
      });
    }
    async feed(sort,page=1) {
      const url=new URL(this.dataset.collectionUrl,window.location.origin);
      url.searchParams.set('view','afs-budget-data');url.searchParams.set('sort_by',sort);url.searchParams.set('page',page);
      const response=await fetch(url,{credentials:'same-origin'});
      if(!response.ok)throw new Error('Catalog unavailable');
      const data=await response.json();
      if(data.currency!==this.dataset.currency||!Array.isArray(data.items)||data.page!==page)throw new Error('Catalog context mismatch');
      return data;
    }
    async allPages(sort) {
      const first=await this.feed(sort);let items=first.items;
      for(let page=2;page<=first.pages;page++){const data=await this.feed(sort,page);items=items.concat(data.items);}
      return [...new Map(items.map(item=>[item.id,item])).values()];
    }
    async load() {
      this.loading.hidden=false;this.failure.hidden=true;this.grid.setAttribute('aria-busy','true');
      try {this.items=await this.allPages('manual');this.featured=new Map(this.items.map((item,i)=>[item.id,i]));await this.render();}
      catch (error) {console.error('AFS catalog load',error);this.failure.hidden=false;this.loading.hidden=true;this.querySelector('[data-afs-count]').textContent='';}
      finally {this.grid.removeAttribute('aria-busy');}
    }
    async render() {
      if(!this.items)return;
      const revision=(this.revision||0)+1;this.revision=revision;
      this.loading.hidden=false;this.failure.hidden=true;
      try {
        const url=new URL(window.location.href), sort=this.sort.value;
        this.querySelector('[data-afs-sales-note]').hidden=sort!=='best-selling';
        if(sort==='best-selling'&&!this.sales){const items=await this.allPages('best-selling');this.sales=new Map(items.map((item,i)=>[item.id,i]));}
        if(revision!==this.revision)return;
        const low=this.min.value===''?0:Math.round(Number(this.min.value)*100);
        const high=this.max.value===''?Infinity:Math.round(Number(this.max.value)*100);
        let items=this.items.filter(item=>item.price>=low&&item.price<=high&&(!this.stock.checked||item.available));
        items.sort((a,b)=>{
          switch(sort){case 'price-ascending':return a.price-b.price;case 'price-descending':return b.price-a.price;case 'created-descending':return Number(b.created)-Number(a.created);case 'created-ascending':return Number(a.created)-Number(b.created);case 'title-ascending':return a.title.localeCompare(b.title,this.dataset.locale);case 'title-descending':return b.title.localeCompare(a.title,this.dataset.locale);case 'best-selling':return (this.sales.get(a.id)??Infinity)-(this.sales.get(b.id)??Infinity);default:return this.featured.get(a.id)-this.featured.get(b.id);}
        });
        const pageCount=Math.max(1,Math.ceil(items.length/24));
        const page=Math.min(pageCount,Math.max(1,Number.parseInt(url.searchParams.get('page')||'1',10)||1));
        this.querySelector('[data-afs-count]').textContent=this.labels.count.replace('__COUNT__',String(items.length));
        this.querySelector('[data-afs-empty]').hidden=items.length!==0;
        this.grid.replaceChildren(...items.slice((page-1)*24,page*24).map(item=>this.card(item)));
        this.pages.replaceChildren();
        if(pageCount>1){
          for(const n of [...new Set([1,page-1,page,page+1,pageCount])].filter(n=>n>=1&&n<=pageCount).sort((a,b)=>a-b)){
            const link=document.createElement('a');const target=new URL(url);target.searchParams.set('page',n);link.href=target.toString();link.textContent=String(n);
            if(n===page)link.setAttribute('aria-current','page');
            link.addEventListener('click',event=>{if(event.ctrlKey||event.metaKey||event.shiftKey)return;event.preventDefault();this.navigate(target);this.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});
            this.pages.append(link);
          }
        }
      }catch{if(revision===this.revision){this.failure.hidden=false;this.grid.replaceChildren();this.pages.replaceChildren();this.querySelector('[data-afs-count]').textContent='';this.querySelector('[data-afs-empty]').hidden=true;}}
      finally{if(revision===this.revision)this.loading.hidden=true;}
    }
    card(item) {
      const li=document.createElement('li');li.dataset.price=String(item.price);li.dataset.productId=item.id;
      const link=document.createElement('a');link.href=item.url;
      if(item.image){const image=document.createElement('img');image.src=item.image;image.alt=item.title;image.loading='lazy';image.width=480;image.height=640;link.append(image);}
      const title=document.createElement('h3');title.textContent=item.title;link.append(title);
      const price=document.createElement('p');price.className='afs-budget-product-price';const amount=this.money.format(item.price/100);price.textContent=item.priceVaries?this.labels.from.replace('__AMOUNT__',amount):amount;link.append(price);
      const action=document.createElement('span');action.className='afs-budget-view';action.textContent=this.labels.view;link.append(action);li.append(link);return li;
    }
  });
}
